export namespace ISectionLoggingData {
  /**
   * Return an instance of ISectionLoggingData with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ISectionLoggingData>
  ): ISectionLoggingData =>
    ({
      ...(partial ?? {}),
    }) as ISectionLoggingData;
}

/**
 * Logging data relating the SD UI section and all children
 */
export interface ISectionLoggingData {
  /**
   * A human readable string providing the type of the section instance
   */
  section_type: string | undefined;
  /**
   * An integer representing the 1 based position of the section relative to other sections
   */
  section_position: number | undefined;
}
